import type { ReactNode } from "react";

/**
 * Diskret SEO-note i bunden af en side. Læses som en redaktionel efterskrift,
 * ikke som fyld – samme stemme som resten af Flâneriet.
 */
export function SeoNote({ eyebrow, children }: { eyebrow?: string; children: ReactNode }) {
  return (
    <section className="py-12 border-t border-rule">
      <div className="mx-auto max-w-3xl text-center">
        {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
        <div className="font-serif text-[0.95rem] md:text-[1.05rem] leading-[1.7] text-ink opacity-80 space-y-4">
          {children}
        </div>
      </div>
    </section>
  );
}
